module.exports = __webpack_public_path__ + "a94a70efc30738f8d3230f7ab93250e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/close-icon-sw.png
// module id = 22
// module chunks = 0